module.exports = __webpack_public_path__ + "img/card-logo.8d44efaf.png";